// Operational Dashboard Types
export interface DashboardStats {
  totalHotels: number;
  activeGuests: number;
  pendingAlerts: number;
  documentsToValidate: number;
  totalRevenue: number;
  occupancyRate: number;
}

export interface HotelMetrics {
  hotelId: string;
  hotelName: string;
  occupancyRate: number;
  totalGuests: number;
  activeAlerts: number;
  revenue: number;
  lastUpdate: string;
}

export interface RecentActivity {
  id: string;
  type: 'checkin' | 'checkout' | 'alert' | 'document' | 'message';
  description: string;
  hotelName: string;
  timestamp: string;
  severity?: 'low' | 'medium' | 'high' | 'critical';
}

export interface AlertSummary {
  id: string;
  type: string;
  severity: 'low' | 'medium' | 'high' | 'critical';
  description: string;
  hotelName: string;
  guestName?: string;
  timestamp: string;
  status: 'active' | 'acknowledged' | 'resolved';
}

export interface SystemMetrics {
  cpuUsage: number;
  memoryUsage: number;
  diskUsage: number;
  networkLatency: number;
  activeConnections: number;
  requestsPerMinute: number;
}

export const ALERT_SEVERITY_COLORS = {
  low: '#10B981',
  medium: '#F59E0B',
  high: '#EF4444',
  critical: '#7C2D12'
} as const;

export const ACTIVITY_TYPE_ICONS = {
  checkin: '🏨',
  checkout: '🚪',
  alert: '⚠️',
  document: '📄',
  message: '💬'
} as const;
